import { render } from "./MatchesDashboard.vue?vue&type=template&id=98a91e8a&scoped=true"
import script from "./MatchesDashboard.vue?vue&type=script&lang=js"
export * from "./MatchesDashboard.vue?vue&type=script&lang=js"

import "./MatchesDashboard.vue?vue&type=style&index=0&id=98a91e8a&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a91e8a"]])

export default __exports__